module.exports = __webpack_public_path__ + "img/icon-card-1.1783b5a7.webp";